export default "__VITE_ASSET__CPRXn_gw__"